import { ROUTES } from "@/utils/routes";
import {
  Home,
  LayoutDashboard,
  FileText,
  FileCheck,
  MessageSquare,
  Receipt,
  Star,
  Settings,
  Wallet,
  CircleDollarSign,
  Building,
  Users,
  User,
  FileUp,
  GraduationCap,
  Calendar,
  ThumbsUp,
  Heart,
  Clock,
  FileCog,
  PieChart,
  BarChart,
  LineChart,
  TrendingUp,
  DollarSign,
  Sparkles,
  Brain,
  Bot,
  Zap,
  UserPlus,
  School,
  BookOpen,
  Briefcase,
  Palette,
  BookMarked,
  Book
} from "lucide-react";

export type NavItem = {
  name: string;
  href: string;
  icon: any;
  badge?: {
    count: number;
    color?: string;
  };
  isPremium?: boolean;
  roles?: ("freelancer" | "Enterprise")[];
  subItems?: {
    name: string;
    href: string;
  }[];
};

export const mainNavigation: NavItem[] = [
  {
    name: "Dashboard",
    href: "/dashboard",
    icon: LayoutDashboard,
    roles: ["freelancer", "Enterprise"]
  },
  {
    name: "Projects",
    href: "/projects",
    icon: FileText,
    roles: ["freelancer"]
  },
  {
    name: "Jobs",
    href: ROUTES.MYJOBS,
    icon: FileText,
    roles: ["Enterprise"]
  },
  // {
  //   name: "Submit Project",
  //   href: "/create-job",
  //   icon: FileUp,
  //   roles: ["Enterprise"]
  // },
  // {
  //   name: "Project Collaborations",
  //   href: "/project-collaborations",
  //   icon: Users,
  //   badge: {
  //     count: 8,
  //     color: "bg-indigo-100 text-indigo-600",
  //   },
  //   roles: ["Enterprise"]
  // },
  {
    name: "Find Freelancers",
    href: "/freelancers",
    icon: Users,
    roles: ["Enterprise"]
  },
  {
    name: "Contracts",
    href: "/contracts",
    icon: FileCog,
    roles: ["freelancer", "Enterprise"]
  },
  {
    name: "Profile",
    href: "/profile",
    icon: User,
    roles: ["freelancer", "Enterprise"]
  }
  // {
  //   name: "Digital Portfolio",
  //   href: "/digital-portfolio",
  //   icon: Palette,
  // },
  // {
  //   name: "Documentation",
  //   href: "/documentation",
  //   icon: Book,
  // },
  // {
  //   name: "AI Job Matching",
  //   href: "/ai-job-matching",
  //   icon: Brain,
  // },
  // {
  //   name: "AI Agents",
  //   href: "/ai-agents",
  //   icon: Bot,
  //   isPremium: true,
  //   badge: {
  //     count: 0,
  //     color: "bg-violet-100 text-violet-600",
  //   },
  // },
  // {
  //   name: "Marketplace",
  //   href: "/marketplace",
  //   icon: CircleDollarSign,
  // },
  // {
  //   name: "Messages",
  //   href: "/messages",
  //   icon: MessageSquare,
  //   badge: {
  //     count: 3,
  //     color: "bg-emerald-100 text-emerald-600",
  //   },
  // },
  // {
  //   name: "Proposals",
  //   href: "/proposals",
  //   icon: FileCheck,
  // },
  // {
  //   name: "Reviews",
  //   href: "/reviews",
  //   icon: Star,
  // },
];

// export const accountNavigation: NavItem[] = [
//   {
//     name: "Profile",
//     href: "/profile",
//     icon: User,
//   },
//   {
//     name: "Settings",
//     href: "/settings",
//     icon: Settings,
//   },
//   {
//     name: "Wallet",
//     href: "/wallet",
//     icon: Wallet,
//   },
// ];

// export const workNavigation: NavItem[] = [
//   {
//     name: "Agency",
//     href: "/agency",
//     icon: Building,
//   },
//   {
//     name: "Freelancers",
//     href: "/freelancers",
//     icon: Users,
//   },
//   {
//     name: "Team Builder",
//     href: "/team-builder",
//     icon: UserPlus,
//   },
//   {
//     name: "Client",
//     href: "/client",
//     icon: User,
//   },
//   {
//     name: "Enterprise Training",
//     href: "/enterprise/training",
//     icon: School,
//   },
//   {
//     name: "Freelancer Training",
//     href: "/freelancer-training",
//     icon: BookOpen,
//   },
//   {
//     name: "Skills Test",
//     href: "/skills-test",
//     icon: GraduationCap,
//   },
//   {
//     name: "Interviews",
//     href: "/interviews",
//     icon: Calendar,
//   },
//   {
//     name: "Job Swipe",
//     href: "/job-swipe",
//     icon: ThumbsUp,
//   },
//   {
//     name: "Liked Jobs",
//     href: "/liked-jobs",
//     icon: Heart,
//   },
//   {
//     name: "Posts",
//     href: "/posts",
//     icon: FileText,
//   },
//   {
//     name: "Time Tracking",
//     href: "/time-tracking",
//     icon: Clock,
//   },
//   {
//     name: "Contracts",
//     href: "/contracts",
//     icon: FileCog,
//   },
// ];

// export const reportsNavigation: NavItem[] = [
//   {
//     name: "ROI Calculator",
//     href: "/roi-calculator",
//     icon: PieChart,
//   },
//   {
//     name: "Performance",
//     href: "/performance",
//     icon: TrendingUp,
//   },
//   {
//     name: "Income",
//     href: "/income",
//     icon: DollarSign,
//   },
//   {
//     name: "Analytics",
//     href: "/analytics", 
//     icon: LineChart,
//   },
// ];

export const secondaryNavigation = [
  {
    name: "Help Center",
    href: "/help",
  },
  {
    name: "Partner Program",
    href: "/partners",
  },
  {
    name: "Privacy Policy",
    href: "/privacy",
  },
  {
    name: "Terms of Service",
    href: "/terms",
  },
];

export const categories = {
  // all: [...mainNavigation, ...accountNavigation, ...workNavigation, ...reportsNavigation],
  all: [...mainNavigation],
  main: mainNavigation,
  // account: accountNavigation,
  // work: workNavigation,
  // reports: reportsNavigation,
  pinned: [] // This will be populated dynamically in the sidebar component
};
